<template>
  <div slot="content" class="tooltip-content" @click="updateProjectStorage(projectFields)">
    <p>已持续{{ days }}天</p>
    <template v-if="step === '项目创建'">
      <!-- <el-badge
        v-for="(item, label) in projectDetail"
        :key="label"
        :hidden="item.新增 === 0"
        :value="item.新增"
        class="item"
      > -->
      <p v-for="(item, label) in projectDetail" :key="label">
        {{ `${label}： ${item.已填写}/${item.字段数}` }}
        <span v-if="item.新增 !== 0" class="tooltip-badge">{{ item.新增 }}</span>
      </p>
      <!-- </el-badge> -->
      <!-- <p v-for="(item, label) in projectDetail" :key="label">{{ `${label}： ${item.已填写}/${item.字段数}` }}</p> -->
    </template>
    <template v-else-if="step === '人才搜寻'">
      <p>加入项目人选（{{ radishSearchDetail.已搜寻 || 0 }}）</p>
      <p>已沟通人选（{{ radishSearchDetail.已沟通 || 0 }}）</p>
    </template>
    <template v-else-if="step === '职位推荐'">
      <p>已推荐：{{ recommendDetail.已推荐 || 0 }}</p>
      <p>最新推荐：{{ recommendDetail.最新推荐 }}</p>
      <p>推荐中：{{ recommendDetail.推荐中 }}</p>
    </template>
    <template v-else-if="step === '面试阶段'">
      <p>面试中：{{ interviewDetail.面试中 || 0 }}</p>
      <p>一面：{{ interviewDetail.一面 || 0 }}</p>
      <p>复面：{{ interviewDetail.复面 || 0 }}</p>
    </template>
    <template v-else-if="step === 'offer谈判'">
      <p>终面：{{ finalInterviewDetail.终面 || 0 }}</p>
      <p>offer谈判：{{ finalInterviewDetail.offer谈判 || 0 }}</p>
      <p>终面人选：{{ (finalInterviewDetail.终面人选 || []).join('、') }}</p>
      <p>offer谈判人选：{{ (finalInterviewDetail.offer谈判人选 || []).join('、') }}</p>
    </template>
    <template v-else-if="step === '离职管理'">
      <p>offer数：{{ offerDetail.offer数 || 0 }}</p>
      <p>offer人选：{{ (offerDetail.人选 || []).join('、') }}</p>
    </template>
    <template v-else-if="step === '开票催款'">
      <p>到岗：{{ toworkDetail.到岗 || 0 }}</p>
      <p>过保：{{ toworkDetail.过保 || 0 }}</p>
    </template>
  </div>
</template>
<script>
const dateFormat = require('dateformat')

const mapObj = {
  职位JD: ['岗位职责', '岗位要求'],
  客户信息: ['核心要求', '面试流程', '关键面试人', '对接hr', '客户特殊要求'],
  寻访方向: ['寻访方向', '目标公司', '典型目标人选'],
  亮点优势: ['职位亮点及优势', '部门详情', '阿尔法认知'],
  人才画像: ['职能模块', '擅长方向', '目标行业', '平台', '职级', '业绩', '地域'],
}
const projectFields = []
Object.keys(mapObj).forEach(v => {
  projectFields.push(...mapObj[v])
})

export default {
  props: {
    project: { type: Object, default: () => ({}) },
    step: { type: String, default: '' },
    days: { type: Number, default: 0 },
    getPipeline: { type: Boolean, default: false },
  },
  data() {
    return {
      projectDetail: {},
      radishSearchDetail: {},
      recommendDetail: {},
      interviewDetail: {},
      finalInterviewDetail: {},
      offerDetail: {},
      toworkDetail: {},
      projectStorage: {},
      projectFields: projectFields,
    }
  },
  watch: {
    getPipeline(newValue, oldValue) {
      if (newValue === true) this.init()
    },
  },
  methods: {
    checkBadge() {
      const { project } = this
      const storage = localStorage.getItem('projectHistory')
      const obj = (storage && JSON.parse(storage)) || {}
      // if(obj[project._id]){

      // }
      this.projectStorage = obj[project._id] || {}
    },
    updateProjectStorage(badgeFields) {
      if (this.step !== '项目创建') return
      const storage = localStorage.getItem('projectHistory')
      let obj = {}
      try {
        obj = (storage && JSON.parse(storage)) || {}
      } catch (e) {
        console.log(e)
      }
      obj[this.project._id] = obj[this.project._id] || {}
      badgeFields.forEach(field => {
        obj[this.project._id][field] = this.project.修改历史[field]
      })
      localStorage.setItem('projectHistory', JSON.stringify(obj))
      window.open(`${window.origin}/#/project20/${this.project._id}?defaultActiveTab=详情`)
    },
    init() {
      this.checkBadge()
      if (this.step === '项目创建') {
        this.checkProjectDetail()
      } else if (this.step === '人才搜寻') {
        this.checkRadishSearch()
      } else if (this.step === '职位推荐') {
        this.checkRadishRecommend()
      } else if (this.step === '面试阶段') {
        this.checkRadishInterview()
      } else if (this.step === 'offer谈判') {
        this.checkFinalInterview()
      } else if (this.step === '离职管理') {
        this.checkOffer()
      } else if (this.step === '开票催款') {
        this.checkTowork()
      }
    },
    checkTowork() {
      const toworkDetail = {}
      const radishProject = this.project.radish_project || []

      const arr = radishProject.filter(
        v => v.状态 && (v.状态.tag === '到岗' || v.状态.tag === '过保') && v.状态.detail !== '淘汰',
      )

      toworkDetail.到岗 = arr.filter(v => v.状态.tag === '到岗').length
      toworkDetail.过保 = arr.filter(v => v.状态.tag === '过保').length

      this.toworkDetail = toworkDetail
    },
    checkOffer() {
      const offerDetail = {}
      const radishProject = this.project.radish_project || []
      const offers = this.project.offers || []

      const arr = radishProject.filter(
        v => v.状态 && v.状态.tag === 'offer' && v.状态.detail !== '淘汰' && v.状态.detail !== '放弃',
      )

      offerDetail.offer数 = arr.length
      offerDetail.人选 = arr.map(v => {
        const offer = offers.find(val => val.rid === v.rid)
        return offer && offer.候选人
      })

      this.offerDetail = offerDetail
    },
    checkFinalInterview() {
      const finalInterviewDetail = {}
      const radishProject = this.project.radish_project || []
      const interviews = this.project.interviews || []
      const offers = this.project.offers || []

      const arr1 = radishProject.filter(v => v.状态 && (v.状态.tag === '面试' && v.状态.detail === '终面'))
      const arr2 = radishProject.filter(v => v.状态 && v.状态.tag === 'offer谈判' && v.状态.detail !== '淘汰')

      finalInterviewDetail.终面 = arr1.length
      finalInterviewDetail.offer谈判 = arr2.length
      finalInterviewDetail.终面人选 = arr1
        .map(v => {
          const interview = interviews.find(val => val.rid === v.rid)
          return interview && interview.候选人
        })
        .filter(v => v)
      finalInterviewDetail.offer谈判人选 = arr2
        .map(v => {
          const offer = offers.find(val => val.rid === v.rid)
          return offer && offer.候选人
        })
        .filter(v => v)

      this.finalInterviewDetail = finalInterviewDetail
    },
    checkRadishInterview() {
      const radishProject = this.project.radish_project || []

      const interviewDetail = { 面试中: 0, 一面: 0, 复面: 0 }

      const arr = radishProject.filter(
        v => v.状态 && (v.状态.tag === '面试' && v.状态.detail !== '终面' && v.状态.detail !== '淘汰'),
      )
      interviewDetail.面试中 = arr.length
      interviewDetail.一面 = arr.filter(v => v.状态.detail === '第1轮').length
      interviewDetail.复面 = arr.filter(v => v.状态.detail !== '第1轮').length

      this.interviewDetail = interviewDetail
    },
    checkRadishRecommend() {
      const recommendDetail = {}
      const radishProject = this.project.radish_project || []
      const recommends = this.project.recommends || []

      const contacting = radishProject.filter(
        v => v.状态 && v.状态.tag === '已推荐' && v.状态.detail !== '淘汰' && v.状态.detail !== '放弃',
      )

      recommendDetail.已推荐 = recommends.length
      recommends.sort((a, b) => b.updatedAt - a.updatedAt)
      recommendDetail.最新推荐 = recommends[0] && dateFormat(recommends[0].updatedAt, 'yyyy-mm-dd')
      recommendDetail.推荐中 = contacting.length

      this.recommendDetail = recommendDetail
    },
    checkRadishSearch() {
      const searchRadishDetail = {}
      const radishProject = this.project.radish_project || []

      searchRadishDetail.已搜寻 = radishProject.length
      const haveContacted = radishProject.filter(v => v.意向)
      searchRadishDetail.已沟通 = haveContacted.length

      this.radishSearchDetail = searchRadishDetail
    },
    checkProjectDetail() {
      let toUpdate = false
      const account = app.user.account
      const newProjectHistory = this.project.修改历史 || {}
      const { projectStorage } = this
      const result = {}
      for (const label in mapObj) {
        const fields = mapObj[label]
        const obj = { 已填写: 0, 未填写: 0, 字段数: fields.length, 新增: 0 }
        // eslint-disable-next-line no-loop-func
        fields.forEach(field => {
          const val = this.project[field]
          if (Array.isArray(val)) {
            if (val.length !== 0) obj.已填写 += 1
            else obj.未填写 += 1
          } else if (val) obj.已填写 += 1
          else obj.未填写 += 1
          if (newProjectHistory[field] && newProjectHistory[field].updatedBy !== account) {
            if (JSON.stringify(newProjectHistory[field] || {}) !== JSON.stringify(projectStorage[field] || {})) {
              toUpdate = true
              obj.新增 += 1
            }
          }
        })
        result[label] = obj
      }
      this.projectDetail = result

      // if (toUpdate) this.updateProjectStorage()
    },
    dateFormat(time, format) {
      return dateFormat(time, format)
    },

    passed(date) {
      return date ? `${Math.ceil((Date.now() - date) / (24 * 3600 * 1000))}` : ''
    },
  },
}
</script>
<style scoped>
.bolder {
  font-weight: 700;
}
.tooltip-content p {
  display: flex;
  align-items: center;
}
.tooltip-badge {
  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  margin-left: 10px;
}
</style>
